import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog'
import { ConfirmSubscriptionRequest, EditSubscriptionRequest, Product, ProductRealTimePriceRequest, ProductRealTimePriceRequestItem, SusbscribedItemDetails, SusbscribedProducts } from '../../../shared/models/product';
import { UserService } from '../../../core/services/user.service';
import { OrderAccount } from '../../order/order.constant';
import { OrderService } from '../../order/order.service';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { StaticConstants } from '../../../core/constants/static.constants';
import { TypeRefs } from '../../../shared/models/static-data';
import { DatePipe } from '@angular/common';
import { ProductsService } from '../products.service';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { CacheConstant, CacheDuration } from '../../../core/constants/app.constant';
import { ConfirmSubscriptionComponent } from '../confirm-subscription/confirm-subscription.component';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { NgForm } from '@angular/forms';
import { ProductRoutes, RoutePrefix } from '../../../core/constants/routes.constant';
import { Router } from '@angular/router';
import { AdditionalConfirmSubscriptionComponent } from '../additional-confirm-subscription/additional-confirm-subscription.component';
import { CreditCard } from '../../../shared/models/credit-card';
import { PaymentOptions } from '../../order/order.constant';
import { CreditCardsService } from '../../../modules/credit-cards/credit-cards.service';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';

@Component({
  selector: 'subscribe-dialog',
  templateUrl: './subscribe-dialog.component.html',
  styleUrls: ['./subscribe-dialog.component.scss']
})
export class SubscribeDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SubscribeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public productData: any,
    private userService: UserService, private orderService: OrderService, public datepipe: DatePipe,
    private productService: ProductsService, private cache: AppCacheService,
    private dialog: MatDialog, private router: Router,
    private creditCardService: CreditCardsService) { }

  envProperties = this.cache.get(CacheConstant.Env_Properties);
  noOfDaysToChangeSubscription = this.envProperties.noOfDaysToChangeSubscription;
  shippingCost = this.envProperties.shippingCost;
  subscriptionMinOrderCheck: boolean = this.envProperties.subscriptionMinOrderCheck;
  showSubscriptionMinOrderMsg: boolean = false;
  ordersList: Array<any> = [];
  unavailableItemsList: Array<any> = [];
  cacheSubData: any;
  qtyLength = this.envProperties.qtyFieldLength;
  subscribeDatasource: MatTableDataSource<any> = new MatTableDataSource();
  websiteName = this.envProperties.theme;
  caseAlertObject: any;
  tax: any;
  discount: any;
  subTotal: any;
  totalAmount: any;
  minSubscriptionValue: number
  isLowSubscriptionTotal: boolean = false;
  detailsLoading: boolean = false;
  balanceTotal: number;
  minStartDate: Date;
  minNextDate: Date;
  nextDate: Date;
  showCaseQtyAlert: boolean = false;
  showQtyAlert: boolean = false;
  startDate: Date;
  orderColumns = ['description', 'quantity', 'availableQuantity', 'unitPrice', 'totalPrice', 'actionDelete'];

  confirmSubscriptionRequest: ConfirmSubscriptionRequest = new ConfirmSubscriptionRequest();
  editSubscriptionRequest: EditSubscriptionRequest = new EditSubscriptionRequest();
  subscriptionFrequency: Array<TypeRefs> = [];
  selectedFrequency: number;
  confirmStartDate: string;
  confirmNextDate: string;
  subscribedItems: SusbscribedProducts = new SusbscribedProducts();
  enableUpdateButton: Boolean = false;
  enableDeleteButton: Boolean = false;
  enableConfirmSubcribe: Boolean = false;
  enableApply: Boolean = false;
  msg: String;
  title: String;
  initialFrequency: any;
  cachedata: any;
  cacheSubscribedData: any;
  action: any;
  subscriptions: number;
  isCacheSubscribedDataAvailable: boolean = false;
  isUnavailable: number = 0;
  unavailableItems: String = null;
  userAuthDetail = this.cache.get(CacheConstant.User_Auth_Detail);
  userAuthAccounts = this.userAuthDetail.accounts;
  defaultAccount = this.userService.getDefaultAccount();
  defaultSoldAcc = this.defaultAccount.accountSoldToNum;
  termType: any;
  creditCardFlag: Boolean = false;
  addCreditCardMsg: Boolean = false;
  creditCards: CreditCard[] = [];
  selectedCreditCard: any;
  selectedPayOnTerms: boolean;
  selectedCreditCardPayment: boolean;
  payOptionChosen: Boolean;
  selectedOption: PaymentOptions = PaymentOptions.None;
  selectOneCard: Boolean = true;
  defaultAccountMasterDetails: any;
  warehouse: any;
  isUpdatable: Boolean =true;
  cardDetail: any=null;

  ngOnInit() {
    this.defaultAccountMasterDetails = this.userService.getDefaultAccountMasterData();
    if (this.websiteName === 'Major') {
      this.warehouse = this.defaultAccountMasterDetails.wareHouse
    }
    this.action = this.productData.action;
    this.msg = this.productData.message;
    this.title = this.msg === 'Subscribe & Save' ? 'Subscribe & Save' : 'Change Subscription';
    if (this.title === 'Subscribe & Save' && this.envProperties.buId === 1) {
      this.title = 'SubscribeMED';
    }

    this.cachedata = this.cache.get(CacheConstant.Subscription_Data);
    this.cacheSubscribedData = this.cachedata ? this.cachedata.subscriptionData : null

    this.enableUpdateButton = false;
    this.enableConfirmSubcribe = true;

    this.enableApply = true;
    this.caseAlertObject = this.userService.getCaseData();

    this.productData.subscribedItems.itemDetails.forEach(items => {
      this.ordersList.push(items);
      if(!this.checkQunatity(items)){
        this.enableConfirmSubcribe = false;
        this.enableApply = false;
      }
    });
    this.checkInvalidItems(this.ordersList)

    this.enableDeleteButton = this.ordersList.length > 1 ? true : false;
    this.subscribeDatasource = new MatTableDataSource(this.ordersList);
    this.nextDate = this.productData.subscribedItems.startDate;
    this.subTotal = this.productData.subscribedItems.subTotal;
    this.tax = this.productData.subscribedItems.tax;
    this.discount = this.productData.subscribedItems.discount;
    this.totalAmount = (this.productData.subscribedItems.netTotalAmount != 0) ? this.productData.subscribedItems.netTotalAmount : null;

    this.checkMinSubscriptionValue(this.totalAmount);
    this.minStartDate = new Date();
    this.minStartDate.setDate(this.minStartDate.getDate() + 4);
    this.minNextDate = new Date();
    this.minNextDate.setDate(this.minNextDate.getDate() + this.noOfDaysToChangeSubscription + 1);
    this.confirmNextDate = this.datepipe.transform(this.minNextDate, 'yyyy-MM-dd');
    this.subscriptionFrequency = AppUtilService.static.typeRef.byGroup(
      StaticConstants.TypeGroup.SubscriptionFrequency
    );

    this.startDate = this.cachedata ? this.cachedata.date : null;

    this.selectedFrequency = this.cachedata ? this.cachedata.frequency : this.subscriptionFrequency[0].typeCode;
    for (let i = 0; i < this.subscriptionFrequency.length; i++) {
      if (this.subscriptionFrequency[i].typeDesc == this.productData.subscribedItems.frequency)
        this.initialFrequency = this.subscriptionFrequency[i].typeCode;
    }
    this.selectedCreditCard = 'Please select a credit card';
    this.getTermTypeForDefaultSoldTo();
    this.checkSubscriptionEditable();
    if (this.websiteName === 'Major') {
      this.creditCardCheck();
    }
  }

  getTermTypeForDefaultSoldTo() {
    this.userAuthAccounts.forEach(account => {
      if (account.accountNum == this.defaultSoldAcc)
        this.termType = account.termTypeText;
    });
    if (this.termType == 'CREDITCARD') {
      this.selectedOption = PaymentOptions.CreditCard;
    }
    if (this.termType == 'PAYONTERMS') {
      this.selectedOption = PaymentOptions.PayOnTerms;
    }

    this.creditCardFlag = this.termType == 'CREDITCARD' ? true : false
    if (this.termType === 'CREDITCARD') {
      this.selectedCreditCardPayment = true;
      this.selectedPayOnTerms = false;
    } else if (this.termType === 'PAYONTERMS') {
      this.selectedPayOnTerms = true;
      this.selectedCreditCardPayment = false;
    } else {
      this.selectedCreditCardPayment = false;
      this.selectedPayOnTerms = false;
    }
  }

  checkSubscriptionEditable(){
    if(this.websiteName === 'Major' && this.msg === 'Change Subscription') {
      this.isUpdatable= this.productData.subscribedItems.isUpdatable;
      if(this.isUpdatable){
        this.isUpdatable = this.enableSubscribedData(this.productData.subscribedItems.startDate);
      }
      if(this.termType=='BOTH'){
        this.selectedOption=this.productData.subscribedItems.paymentType;
        if(this.selectedOption == PaymentOptions.PayOnTerms){
          this.selectedPayOnTerms = true;
        }
        else{
          this.selectedCreditCardPayment = true;
          this.creditCardFlag=true;
          this.selectOneCard =true;
        }
      }
    }
  }

  enableSubscribedData(deliveryDate) {
    if (this.calculateDiff(deliveryDate) < this.noOfDaysToChangeSubscription) {
      return false;
    }
    return true;
  }
  
  private calculateDiff(data) {
    let date = new Date(data);
    let currentDate = new Date();

    let days = Math.floor((date.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);
    return days;
  }

  creditCardCheck(){
    this.creditCardService.getAll().subscribe((response: any) => {
      if(response && !response.hasError){
         this.creditCards= []
        response.forEach(card => {
          this.creditCards.push(card as CreditCard);
          if(this.websiteName == 'Major' && this.msg == 'Change Subscription' && this.selectedOption == PaymentOptions.CreditCard){
            if(card.cardNumber==this.productData.subscribedItems.creditCardDetails.cardNumber){
              this.selectedCreditCard=card;
            }
          }
        });  
      }
      if(this.creditCards.length==0)
        this.addCreditCardMsg= true;
      
    });
  }

  onCreditCardButtonSelect() {
    this.creditCardFlag = true;
    this.selectedCreditCardPayment = true;
    this.selectedOption = PaymentOptions.CreditCard;
    this.selectOneCard = true;

  }

  onPayOnTermSelect(event: MatRadioChange) {
    this.creditCardFlag = false;
    this.selectedPayOnTerms = true;
    this.selectedOption = PaymentOptions.PayOnTerms;
  }

  goToMangeCreditPage() {
    this.dialogRef.close(false);
    this.router.navigate([RoutePrefix.CreditCards]);

  }

  checkInvalidItems(ordersList) {
    this.unavailableItemsList = [];
    this.isUnavailable = 0;
    ordersList.forEach(items => {
      if (items.isAvailable == false) {
        this.unavailableItemsList.push(items.itemId);
        this.isUnavailable = this.isUnavailable + 1;
      }
      if (
        this.unavailableItemsList &&
        this.unavailableItemsList.length > 0
      ) {
        this.unavailableItems = this.unavailableItemsList.join(', ');
      }
    })
  }

  onProductQuantityChange(product: SusbscribedItemDetails) {
    if (this.isValidQuantity(product)) {
      this.enableUpdateButton = true;
      this.enableConfirmSubcribe = false;
      this.enableApply = false;
      this.showQtyAlert = false;
      if (this.websiteName === 'Major') {
        this.showCaseQtyAlert = false;
      }
    }
    else {
      this.enableUpdateButton = false;
      this.enableConfirmSubcribe = false;
      this.enableApply = false;
      if (this.websiteName === 'Major' && this.warehouse === '77') {
        this.showCaseQtyAlert = true;
      }
      else {
        this.showQtyAlert = true;
      }
    }
  }

  checkCaseQtyMultiplier(product: SusbscribedItemDetails): boolean {
    if ((product.orderQuantity == 0 && this.caseAlertObject.showCaseAlert) || (!isNaN(product.orderQuantity) && product.orderQuantity % product.packQuantity != 0 && this.caseAlertObject.showCaseAlert)) return true;
    return false;
  }

  showQuantityWarning(product): boolean {
    if (product.allocationCase === "Low Stock") {
      this.enableConfirmSubcribe = this.enableApply = this.checkQunatity(product);
      return true;
    }
    return false;
  }

  checkQunatity(product){
    const orderQuantity = product.orderQuantity === undefined ? product.quantity : product.orderQuantity
    if(Number(orderQuantity) > Number(product.availableQuantity)){
      return false;
    }
    return true;
  }

  checkMinSubscriptionValue(totalAmount: any) {
    this.minSubscriptionValue = this.getSubscriptionMinValue();
    if (totalAmount != 0 && totalAmount < this.minSubscriptionValue) {
      if (this.subscriptionMinOrderCheck) {
        this.showSubscriptionMinOrderMsg = true;
        this.enableConfirmSubcribe = false;
        this.enableApply = false;
      } else {
        this.isLowSubscriptionTotal = true;
        this.showSubscriptionMinOrderMsg = false;
        this.balanceTotal = this.minSubscriptionValue - totalAmount;
      }
    }
    else {
      this.isLowSubscriptionTotal = false;
      this.showSubscriptionMinOrderMsg = false;
    }
  }

  getSubscriptionMinValue() {
    const subscriptionConfig = this.orderService.getOrderShoppingConfig();
    let minValue = subscriptionConfig.defaultMinOrderValue;
    const accountState = this.defaultAccountMasterDetails.state;
    switch (accountState.toString().toUpperCase()) {
      case OrderAccount.Hawaii:
        minValue = subscriptionConfig.hawaiiMinOrderValue;
        break;

      case OrderAccount.Alaska:
        minValue = subscriptionConfig.alaskaMinOrderValue;
        break;

      default:
        break;
    }
    return minValue;

  }

  onClose() {
    this.isCacheSubscribedDataAvailable = this.cache.has(CacheConstant.Subscription_Data);
    if (this.isCacheSubscribedDataAvailable) {
      this.cache.remove(CacheConstant.Subscription_Data);
    }
    this.dialogRef.close(false);
  }

  onConfirmSubscriptionClick() {
    if (this.selectedCreditCardPayment == true || this.selectedPayOnTerms == true) {
      this.payOptionChosen = true;
    }
    else {
      this.payOptionChosen = false;
    }
    if (this.selectedCreditCard.cardNumber == null) {
      this.selectOneCard = false;
    }
    else {
      this.selectOneCard = true;
    }

    this.confirmSubscriptionRequest.customerSubscriptionItemVO = [];
    const defaultAccount = this.userService.getDefaultAccount();
    if(this.websiteName === 'Major'){
    if (((this.startDate != null) && (this.selectedOption==PaymentOptions.PayOnTerms)) || ((this.startDate != null) &&(this.selectedOption==PaymentOptions.CreditCard && this.selectedCreditCard.cardNumber !=null))) {
      this.confirmStartDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd');
      this.confirmSubscriptionRequest.startDate = this.confirmStartDate;
      this.confirmSubscriptionRequest.frequency = this.selectedFrequency;
      this.confirmSubscriptionRequest.accountShipToNum = defaultAccount.accountShipToNum;
      this.confirmSubscriptionRequest.accountSoldToNum = defaultAccount.accountSoldToNum;
      this.confirmSubscriptionRequest.userDetailNum = defaultAccount.userDetailNum;
      this.confirmSubscriptionRequest.isShippingCost = this.isLowSubscriptionTotal;
      this.confirmSubscriptionRequest.buid = this.envProperties.buId;
      this.confirmSubscriptionRequest.paymentType=this.selectedOption;
      if(this.selectedOption==PaymentOptions.PayOnTerms){
        this.confirmSubscriptionRequest.creditCardNum=null;
      }
      else{
      this.confirmSubscriptionRequest.creditCardNum=this.selectedCreditCard.cardNumber;
      }
      this.ordersList.forEach(product => {
        this.confirmSubscriptionRequest.customerSubscriptionItemVO.push({
          itemId: product.itemId,
          quantity: product.orderQuantity,
          unitPrice: product.unitPrice
        });
      });
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = "additional-confirm-subscription-component";
      this.dialog.open(AdditionalConfirmSubscriptionComponent).afterClosed()
        .subscribe(result => {
          if (result) {
            this.productService.saveSubscription(this.confirmSubscriptionRequest).subscribe((response: any) => {
              if (response && response.hasError) {
                AppUtilService.message.error("Unable to save Subscription");
                this.dialogRef.close(false);
              }
              else {
                this.dialogRef.close(true);
                this.isCacheSubscribedDataAvailable = this.cache.has(CacheConstant.Subscription_Data);
                if (this.isCacheSubscribedDataAvailable) {
                  this.cache.remove(CacheConstant.Subscription_Data);
                }
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = "confirm-subscription-component";
                dialogConfig.width = "480px";
                dialogConfig.data = this.startDate;
                setTimeout(() => {
                  this.dialog.open(ConfirmSubscriptionComponent, dialogConfig);
                }, 1000);
              }
            });
          }
        })

    }
    }
    else{
      if (this.startDate != null){
        this.confirmStartDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd');
        this.confirmSubscriptionRequest.startDate = this.confirmStartDate;
        this.confirmSubscriptionRequest.frequency = this.selectedFrequency;
        this.confirmSubscriptionRequest.accountShipToNum = defaultAccount.accountShipToNum;
        this.confirmSubscriptionRequest.accountSoldToNum = defaultAccount.accountSoldToNum;
        this.confirmSubscriptionRequest.userDetailNum = defaultAccount.userDetailNum;
        this.confirmSubscriptionRequest.isShippingCost = this.isLowSubscriptionTotal;
        this.confirmSubscriptionRequest.buid = this.envProperties.buId;
        this.ordersList.forEach(product => {
          this.confirmSubscriptionRequest.customerSubscriptionItemVO.push({
            itemId: product.itemId,
            quantity: product.orderQuantity,
            unitPrice: product.unitPrice
          });
        });
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = "additional-confirm-subscription-component";
        this.dialog.open(AdditionalConfirmSubscriptionComponent).afterClosed()
        .subscribe(result => {
          if(result){
            this.productService.saveSubscription(this.confirmSubscriptionRequest).subscribe((response: any) => {
              if (response && response.hasError) {
                AppUtilService.message.error("Unable to save Subscription");
                this.dialogRef.close(false);
              }
              else {
                this.dialogRef.close(true);
                this.isCacheSubscribedDataAvailable = this.cache.has(CacheConstant.Subscription_Data);
                if (this.isCacheSubscribedDataAvailable) {
                  this.cache.remove(CacheConstant.Subscription_Data);
                }
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = "confirm-subscription-component";
                dialogConfig.width = "480px";
                dialogConfig.data = this.startDate;
                setTimeout(() => {
                  this.dialog.open(ConfirmSubscriptionComponent, dialogConfig);
                }, 1000);
              }
            });
          }
        })
        
      }
    }
  }

  onUpdateClick() {
    if (this.websiteName === 'Major' && !this.showCaseQtyAlert) {
      this.updateSubscriptionDetails();
      this.enableUpdateButton = false;
    }
    else if (this.websiteName === 'Parmed') {
      this.updateSubscriptionDetails();
      this.enableUpdateButton = false;
    }
    if(this.selectedCreditCard.cardNumber==null){
      this.selectOneCard=false;
    }
    else{
      this.selectOneCard=true;
    }
  }

  private updateSubscriptionDetails() {
    this.subscribedItems.itemDetails = [];
    if (this.ordersList.length > 0) {
      this.detailsLoading = true;
      const itemDetails: Array<ProductRealTimePriceRequestItem> = [];
      this.ordersList.forEach(product => {
        if (!isNaN(product.orderQuantity) && product.orderQuantity > 0) {
          itemDetails.push({
            item: product.itemId,
            quantity: product.orderQuantity
          });
        }
      });
      const defaultAccount = this.userService.getDefaultAccount();
      const realTimeRequest: ProductRealTimePriceRequest = {
        shipTo: defaultAccount.accountShipToNum,
        soldTo: defaultAccount.accountSoldToNum,
        items: itemDetails
      };
      this.productService
        .getTotalAmountFromSubscription(realTimeRequest)
        .subscribe((response: any) => {
          if (!response.hasError) {
            this.totalAmount = response.totalAmount;
            this.checkMinSubscriptionValue(this.totalAmount);
            this.subTotal = response.subTotal;
            this.tax = response.tax;
            this.discount = response.discount;
            response.items.forEach(product => {
              this.ordersList.forEach(items => {
                if (product.item === items.itemId) {
                  this.subscribedItems.itemDetails.push({
                    itemId: product.item,
                    orderQuantity: product.quantity,
                    description: items.description,
                    unitPrice: product.price,
                    totalPrice: product.amount,
                    packQuantity: items.packQuantity,
                    allocatedQuantity: product.allocatedQuantity,
                    isAvailable: items.isAvailable,
                    availableQuantity: product.availableQuantity,
                    allocationCase: product.allocationCase,
                    showQuantityWarning: this.showQuantityWarning(product),
                    priceOverRide: product.priceOverRide

                  });
                }
              });
            });
            this.detailsLoading = false;
          }
          this.ordersList = this.subscribedItems.itemDetails;
          this.subscribeDatasource = new MatTableDataSource(this.ordersList);
          this.enableDeleteButton = this.ordersList.length > 1 ? true : false;
        });

      this.enableConfirmSubcribe = true;
      this.enableApply = true;
    }

  }
  commonApplyFunctionality(){
    this.confirmNextDate = this.datepipe.transform(this.nextDate, 'yyyy-MM-dd');
    this.editSubscriptionRequest.customerSubscriptionItemVO = [];
    this.editSubscriptionRequest.deliverytDate = this.confirmNextDate;
    this.editSubscriptionRequest.frequency = this.initialFrequency;
    this.editSubscriptionRequest.customerSubscriptionId = this.productData.subscribedItems.subscriptionId;
    this.editSubscriptionRequest.isShippingCost = this.isLowSubscriptionTotal;
    this.ordersList.forEach(product => {
      this.editSubscriptionRequest.customerSubscriptionItemVO.push({
        itemId: product.itemId,
        quantity: product.orderQuantity,
        unitPrice: product.unitPrice
      });

    });
    this.productService.editSubscription(this.editSubscriptionRequest).subscribe((response) => {
      if (response && response.hasError) {
        AppUtilService.message.error("Unable to apply the changes as the shipping date lies within a week.");
        this.dialogRef.close(false);
      }
      else {
        AppUtilService.message.success("Changes have been applied successfully");
        this.dialogRef.close(true);
      }
    });
    this.enableApply = true;
  }

  onApplyclick() {
    if(this.websiteName === 'Major'){
      if(this.selectedCreditCard.cardNumber==null){
        this.selectOneCard=false;
      }
      else{
        this.selectOneCard=true;
      }
      if((this.selectedOption==PaymentOptions.PayOnTerms)||(this.selectedOption==PaymentOptions.CreditCard && this.selectOneCard==true)){
        
        this.editSubscriptionRequest.paymentType=this.selectedOption;
        if(this.selectedOption==PaymentOptions.PayOnTerms){
          this.editSubscriptionRequest.creditCardNum=null;
        }
        else{
        this.editSubscriptionRequest.creditCardNum=this.selectedCreditCard.cardNumber;
        }
        this.commonApplyFunctionality();   
      }
    }
    else if(this.websiteName === 'Parmed'){
      this.commonApplyFunctionality();
    }
  }

  isValidQuantity(product: SusbscribedItemDetails): boolean {
    if (!isNaN(product.orderQuantity) && product.orderQuantity > 0) {
      return true;
    }
    else {
      if (this.websiteName === 'Major' && this.warehouse === '77') {
        if (!this.checkCaseQtyMultiplier(product)) {
          return true
        }
      }
    }
  }

  private onDeleteClick(order: ProductRealTimePriceRequestItem) {
    const index: number = this.ordersList.indexOf(order);
    if (index !== -1) {
      this.ordersList.splice(index, 1);
      this.updateSubscriptionDetails();
      this.enableDeleteButton = this.ordersList.length > 1 ? true : false;
      this.checkInvalidItems(this.ordersList);
    }
  }

  onAddAnotherItem() {
    const subscriptionData = {
      subscriptionData: this.productData,
      frequency: this.selectedFrequency,
      date: this.startDate
    }
    this.cache.set(
      CacheConstant.Subscription_Data,
      subscriptionData,
    );
    if (this.action != undefined && this.action === 'Add-Subscription-From-Other-Components') {
      this.router.navigate(['/product/subscription/subscribe-save']);
    }
  }

  onSubscriptionSubmit(form: NgForm) {
    if (form.invalid) {
      return;
    }
  }
}
